import type { Tone } from '../../components/common/ui-kit';
import type { PipelineArtifactStatus, PipelineRunStatus } from '../../types';

/**
 * One meaning, one colour, wherever a pipeline status appears.
 *
 * Cancelled is neutral rather than red: someone chose to stop the run, which is
 * not the same event as a run that broke. Building and running are amber because
 * they are states you wait on, not states you act on.
 */
export const runTone = (s?: PipelineRunStatus | null): Tone => {
  switch (s) {
    case 'COMPLETED': return 'success';
    case 'PARTIAL_FAILED': return 'warn';
    case 'FAILED': return 'danger';
    case 'CANCELLED': return 'neutral';
    case 'RUNNING': return 'warn';
    case 'QUEUED': return 'info';
    default: return 'neutral';
  }
};

export const artifactTone = (s?: PipelineArtifactStatus | null): Tone => {
  switch (s) {
    case 'READY': return 'success';
    case 'BUILDING': return 'warn';
    case 'FAILED': return 'danger';
    case 'RETIRED': return 'neutral';
    default: return 'info';
  }
};

/** A source is either usable by the next run, or it is not. */
export const sourceTone = (s?: string | null): Tone => {
  switch (s) {
    case 'READY': return 'success';
    case 'INVALID': case 'FAILED': return 'danger';
    case 'PENDING': return 'warn';
    default: return 'neutral';
  }
};
